import { Flex, Link, Spacer, Button } from "@chakra-ui/react";
import Logo from "../logo/Logo";

interface INavNode {
  path: string;
  name: string;
  isExternal: boolean;
}

const Header = (): JSX.Element => {
  const navNodes: INavNode[] = [
    {
      path: "/",
      name: "Home",
      isExternal: false,
    },
    {
      path: "https://medium.com/@manishparui",
      name: "Blog",
      isExternal: true,
    },
  ];

  return (
    <Flex
      width={"100%"}
      paddingX={12}
      paddingY={3}
      gap={6}
      alignItems={"center"}
      shadow={"md"}
      position={"fixed"}
      borderBottomWidth={1}
      borderColor={"gray.600"}
      // justifyContent={{ base: "space-between", md: "right" }}
      // backgroundColor="rgba(255, 255, 255, 0.1)" // Semi-transparent white
      backdropFilter={"blur(6px)"}
      zIndex={"sticky"}
    >
      <Logo />

      <Spacer />

      {navNodes.map((navNode) => (
        <Button
          key={navNode.name}
          as={Link}
          variant={"link"}
          color={"neonDefault"}
          href={navNode.path}
          isExternal={navNode.isExternal}
        >
          {navNode.name}
        </Button>
      ))}
    </Flex>
  );
};

export default Header;
